export default __webpack_public_path__ + "static/media/b_wdt_c_0.3703e47b.mp3";